import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AwDialogComponent, DialogOptions } from '@assetworks-llc/aw-component-lib';

/**
 * The one Unsaved Changes dialog (RULE 17, ux-content-styling-rules / ccl-component-expert): an alert, Yes leaves and
 * discards, No stays. `ask()` opens it and resolves with the answer.
 */
@Component({
  selector: 'app-unsaved-changes-dialog',
  imports: [AwDialogComponent],
  template: `
    <aw-dialog
      [visible]="open()"
      [dialogOptions]="options"
      (primaryAction)="answer(true)"
      (secondaryAction)="answer(false)"
      ariaLabel="Unsaved Changes"
    ></aw-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsavedChangesDialogComponent {
  readonly options: DialogOptions = {
    variant: 'alert',
    title: 'Unsaved Changes',
    description: 'You will lose unsaved changes. Proceed?',
    primaryButtonLabel: 'Yes',
    secondaryButtonLabel: 'No',
  };

  readonly open = signal(false);
  private resolve: ((leave: boolean) => void) | null = null;

  /** Opens the dialog; resolves true for Yes (leave), false for No (stay). */
  ask(): Promise<boolean> {
    this.resolve?.(false);
    this.open.set(true);
    return new Promise<boolean>((resolve) => (this.resolve = resolve));
  }

  answer(leave: boolean): void {
    // CCL fires Escape (secondaryAction) on every aw-dialog, open or not.
    if (!this.open()) {
      return;
    }
    this.open.set(false);
    this.resolve?.(leave);
    this.resolve = null;
  }
}
